import { getAxiosInstance } from '../client';
/** Mutation functions for the registration intent */
export const registrationIntentMutations = {
    /**
     * POST /registration-intent/prevention — a prevention signup's first login:
     * its officeless Person, without a page; consumes the intent (#1836).
     */
    enterPrevention: () => getAxiosInstance()
        .post('/registration-intent/prevention')
        .then(() => undefined),
};
//# sourceMappingURL=registration-intent.mutations.js.map